import {
  CONFIRMED_CREATE_PATIENT_GAPLD,
  CONFIRMED_DELETE_PATIENT_GAPLD,
  CONFIRMED_EDIT_PATIENT_GAPLD,
  CONFIRMED_GET_PATIENT_GAPLD,
} from "../actions/PatientGapldType"

const initialState = {
  patientGapldEntries: [],
  loading: false,
  error: null,
}

export default function PatientGapldReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_PATIENT_GAPLD:
      console.log("Reducer - GET_PATIENT_GAPLD payload:", action.payload)
      return {
        ...state,
        patientGapldEntries: action.payload || [],
        loading: false,
        error: null,
      }

    case CONFIRMED_CREATE_PATIENT_GAPLD:
      console.log("Reducer - CREATE_PATIENT_GAPLD payload:", action.payload)
      return {
        ...state,
        patientGapldEntries: [...state.patientGapldEntries, action.payload],
        loading: false,
        error: null,
      }

    case CONFIRMED_EDIT_PATIENT_GAPLD:
      console.log("Reducer - EDIT_PATIENT_GAPLD payload:", action.payload)
      const updatedEntries = state.patientGapldEntries.map((entry) =>
        entry.gapld_id === action.payload.gapld_id ? { ...entry, ...action.payload } : entry
      )
      return {
        ...state,
        patientGapldEntries: updatedEntries,
        loading: false,
        error: null,
      }

    case CONFIRMED_DELETE_PATIENT_GAPLD:
      console.log("Reducer - DELETE_PATIENT_GAPLD payload:", action.payload)
      const filteredEntries = state.patientGapldEntries.map((entry) =>
        entry.gapld_id === action.payload.gapld_id ? { ...entry, gapld_status: "Delete" } : entry
      )
      return {
        ...state,
        patientGapldEntries: filteredEntries,
        loading: false,
        error: null,
      }

    default:
      return state
  }
}
